export enum ActivityItemType {
  USER = 'user',
  CRUNCH = 'crunch',
  TEAM = 'team',
  PROJECT = 'project',
  FOLDER = 'folder',
}

export enum ActivityCategory {
  USER = 'user',
  CRUNCH = 'crunch',
  CRUNCH_URP = 'crunch_urp',
  CRUNCH_ANNOTATION = 'crunch_annotation',
  CRUNCH_CHECKLIST = 'crunch_checklist',
  CRUNCH_CHEATSHEET_ANSWER = 'crunch_cheatsheet_answer',
  ADMIN = 'admin',
  FOLDER = 'folder',
  PROJECT = 'project',
}

export enum ActivitySubCategory {
  LOGIN = 'login',
  LOGOUT = 'logout',
  LOGIN_FAILURE = 'login_failure',
  REGISTERED = 'registered',
  INVITED = 'invited',
  INVITE_ACCEPTED = 'invite_accepted',
  CREATED = 'created',
  UPDATED = 'updated',
  REVIEWED = 'reviewed',
  OPENED = 'opened',
  ARCHIVED = 'archived',
  UNARCHIVED = 'unarchived',
  DOWNLOADED = 'downloaded',
  OPEN_DOWNLOAD = 'open_download',
  DELETED = 'deleted',
  RESTORED = 'restored',
  RENAMED = 'renamed',
  MOVED = 'moved',
  SHARED = 'shared',
  SHARE_ACCEPTED = 'share_accepted',
  SHARE_REVOKED = 'share_revoked',
  SHARE_UNREVOKED = 'share_unrevoked',
  SHARE_RESENT = 'share_resent',
}

export enum ActivityStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface ActivityData {
  app_name: string
  actor_guid: string
  activity_guid?: string
  item_guid?: string
  item_type?: ActivityItemType
  category: ActivityCategory
  sub_category: ActivitySubCategory
  data: {
    user: string
    branch: string
    status: ActivityStatus
    [key: string]: string | number | boolean
  }
}

export interface PostActivityRequest {
  activityGuid?: string
  itemGuid?: string
  itemType?: ActivityItemType
  category: ActivityCategory
  subCategory: ActivitySubCategory
  success: boolean
  data?: Record<string, string | number | boolean>
}

export interface PostActivityResponse {
  activity_guid: string
  success: boolean
}
